export class MediaFileView {
    public mediaFile: File;
    public mediaFilePreview: File;
    public mediaFileBase64: string|ArrayBuffer;
}